
import { supabase } from "@/integrations/supabase/client";
import { createLocalDateTime, normalizeTimeFormat } from "@/utils/timeUtils";

export const checkForTimeConflicts = async (
  selectedDate: Date | undefined,
  startTime: string,
  endTime: string,
  serviceId: number
) => {
  if (!selectedDate || !startTime || !endTime) return null;
  
  try {
    // Simple local date/time approach - no timezone conversion
    const { date: dateStr } = createLocalDateTime(selectedDate, startTime);
    const startTimeStr = normalizeTimeFormat(startTime);
    const endTimeStr = normalizeTimeFormat(endTime);
    
    console.log(`🔍 Conflict check: ${dateStr} ${startTimeStr} - ${endTimeStr} (local)`);
    
    // Simplified conflict check using only the new local time format
    const { data: conflictingBookings, error } = await supabase
      .from('bookings')
      .select('*')
      .eq('service_id', serviceId)
      .eq('booking_date', dateStr)
      .or(`and(start_time_local.lt.${endTimeStr},end_time_local.gt.${startTimeStr})`);
    
    if (error) throw error;
    
    console.log('🔍 Booking conflict check results:', { 
      searchDate: dateStr, 
      searchTime: `${startTimeStr} - ${endTimeStr}`,
      foundConflicts: conflictingBookings?.length || 0,
      conflicts: conflictingBookings?.map((b: any) => ({
        id: b.id,
        date: b.booking_date,
        time: `${b.start_time_local} - ${b.end_time_local}`,
        status: b.status
      }))
    });
    
    if (conflictingBookings && conflictingBookings.length > 0) {
      return 'This time slot conflicts with an existing booking or blocked time. Please select a different time.';
    }
    
    return null;
  } catch (error) {
    console.error('Error checking for time conflicts:', error);
    return null;
  }
};
